import { create } from 'zustand'

const DEFAULT_FILTERS = {
  lang: null,
  order: 'updateTime',
  state: '401',
  clientVer: null,
  after: null,
  tag: null,
  simple: null,
  id: '',
  tid: '',
  userId: '',
  aid: '',
  afters: [],
}

export const useForm = create((set) => ({
  ...DEFAULT_FILTERS,
  updateLang: (value) => set({ lang: value, after: null, afters: [] }),
  updateOrder: (value) => set({ order: value, after: null, afters: [] }),
  updateState: (value) => set({ state: value, after: null, afters: [] }),
  updateClientVer: (value) =>
    set({ clientVer: value, after: null, afters: [] }),
  updateTag: (value) => {
    if (!value) {
      set({ tag: null, simple: null, after: null, afters: [] })
      return
    }
    if (value === 'Remix') {
      set({ tag: 'Remix', simple: 1, after: null, afters: [] })
    } else {
      set({ tag: value, simple: null, after: null, afters: [] })
    }
  },
  updateId: (value) => set({ id: value, after: null, afters: [] }),
  updateTid: (value) => set({ tid: value, after: null, afters: [] }),
  updateUserId: (value) => set({ userId: value, after: null, afters: [] }),
  updateAid: (value) => set({ aid: value, after: null, afters: [] }),
  setOrder: (order) => set({ order, after: null, afters: [] }),
  filterByUserId: (userId) =>
    set({
      ...DEFAULT_FILTERS,
      userId: userId || '',
    }),
  filterByAid: (aid) =>
    set({
      ...DEFAULT_FILTERS,
      aid: aid || '',
    }),
  goAfter: (nextAfter) =>
    set((state) => {
      if (nextAfter === null) {
        return { after: null }
      }
      const index = state.afters.findIndex((a) => a === nextAfter)
      if (index === -1) {
        return { after: nextAfter, afters: [...state.afters, nextAfter] }
      } else {
        return { after: nextAfter }
      }
    }),
}))
